import { FacetKey, Facets, isFacetVisibleForUser, SearchParams, SelectedFacet } from '@lessonup/typescript-core/domain';
import { TagList } from '@lessonup/typescript-core/ui';
import { includes } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface SearchResultEmptyStateProps {
  searchParams: SearchParams;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type -- auto-generated TECH-258
  handleFacetDeselect: Function;
}

const TRANSLATION_NAMESPACE = 'search';

const canFilterFacet = (facet: SelectedFacet): boolean => {
  if (facet.fixed) return false;
  return !nonfilterableFacets[facet.key];
};

type NonfilterableFacets = Partial<{
  [key in FacetKey]: boolean;
}>;
const nonfilterableFacets: NonfilterableFacets = {
  hasImage: true,
};

type WithLabel = {
  key: FacetKey;
  label: string;
};
export default function SearchResultsEmptyState(props: SearchResultEmptyStateProps) {
  const { t } = useTranslation(TRANSLATION_NAMESPACE);

  const tags = props.searchParams.facets
    .filter(canFilterFacet)
    .filter(({ key }) => isFacetVisibleForUser(key))
    .map((facet) => {
      const label = Facets.facetLabel(facet, 'nl', 'vo');
      return { key: facet.key, label: label && includes(['test', 'channelLesson'], label) ? t(label) : label };
    })
    .filter<WithLabel>((facet): facet is WithLabel => !!facet.label);

  const removeParam = (facetKey: FacetKey) => {
    props.handleFacetDeselect(facetKey);
  };

  return (
    <>
      {props.searchParams.text && <p>{t('no-result-text', { ns: TRANSLATION_NAMESPACE })}</p>}
      {props.searchParams.text && (
        <TagList
          className="search-page-tags removal-tags"
          tags={[{ label: `"${props.searchParams.text}"`, key: 'text' }]}
          onClick={removeParam}
          passiveTooltip={t('remove', { ns: TRANSLATION_NAMESPACE })}
        />
      )}

      {tags.length ? <p>{t('no-result-facets', { ns: TRANSLATION_NAMESPACE })}</p> : null}
      <TagList
        className="search-page-tags removal-tags"
        tags={tags}
        onClick={removeParam}
        passiveTooltip={t('remove', { ns: TRANSLATION_NAMESPACE })}
      />
    </>
  );
}
